import React, { useEffect, useMemo, useState } from "react";
import { getProfitLossReportAPI } from "../../service/AuthService";
import { getReportPage, ReportPagination, ReportToolbar } from "./ReportHelpers";

export default function ProfitLoss() {
  const [type, setType] = useState("ALL");
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const loadReport = async (requestedPage = page, requestedSize = size) => {
    setLoading(true);
    const result = await getProfitLossReportAPI({ type, pageNumber: requestedPage, pageSize: requestedSize });
    const report = getReportPage(result?.response);
    setRows(report.rows);
    setTotalPages(report.totalPages);
    setPage(requestedPage);
    setLoading(false);
  };

  useEffect(() => {
    loadReport(0);
    // Load once with the default report filters.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const visibleRows = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return rows;
    return rows.filter((row) => Object.values(row).some((value) => String(value ?? "").toLowerCase().includes(term)));
  }, [rows, search]);

  return (
    <div className="main standard-report-page">
      <div className="container-fluid"><div className="row"><div className="col-md-12 main-container"><div className="listing-grid">
        <div className="detail-row"><h2>Profit Loss</h2><div className="report-filter-form"><div className="row">
          <div className="col-md-3 form-group"><label htmlFor="profit-loss-type">Type</label><select id="profit-loss-type" className="form-control" value={type} onChange={(e) => setType(e.target.value)}><option value="ALL">All</option><option value="CLIENT">Client</option><option value="AGENT">Agent</option></select></div>
          <div className="col-md-2 report-button-column"><button type="button" className="btn btn-diamond" disabled={loading} onClick={() => loadReport(0)}>{loading ? "Loading..." : "Load"}</button></div>
        </div></div></div>
        <ReportToolbar size={size} search={search} onSearchChange={(e) => setSearch(e.target.value)} onSizeChange={(e) => { const next = Number(e.target.value); setSize(next); loadReport(0, next); }} />
        <div className="table-responsive data-table"><table className="table table-bordered clean-report-table"><thead><tr><th>No.</th><th>User Name</th><th>Level</th><th className="number-column">Casino Pts</th><th className="number-column">Sport Pts</th><th className="number-column">Third Party Pts</th><th className="number-column">Profit/Loss</th></tr></thead><tbody>
          {visibleRows.length ? visibleRows.map((row, index) => <tr key={row.userId || row.userName || index}><td>{page * size + index + 1}</td><td>{row.userName || row.username || "-"}</td><td>{row.level || row.role || "-"}</td><td className="number-column">{row.casinoPts ?? row.casinoPoints ?? 0}</td><td className="number-column">{row.sportPts ?? row.sportPoints ?? 0}</td><td className="number-column">{row.thirdPartyPts ?? row.thirdPartyPoints ?? 0}</td><td className="number-column">{row.profitLoss ?? row.amount ?? 0}</td></tr>) : <tr><td colSpan={7} className="dataTables_empty">{loading ? "Loading report..." : "No data available in table"}</td></tr>}
        </tbody></table></div>
        <ReportPagination page={page} totalPages={totalPages} onChange={loadReport} />
      </div></div></div></div>
    </div>
  );
}
